import firebase from 'firebase';
import { config } from '../config';

//the root app just in case we need it
export const firebaseApp = firebase.initializeApp(config.firebase);

export const db = firebaseApp.database(); //the real-time database
export const auth = firebaseApp.auth(); //the firebase auth namespace
export const storage = firebaseApp.storage();

export const storageKey = 'UID';

export const isAuthenticated = () => {
  return !!auth.currentUser || !!localStorage.getItem(storageKey);
}

export const fbProvider = new firebase.auth.FacebookAuthProvider();


// WEBPACK FOOTER //
// ./src/ThirdPartyIntegration/firebaseClient.js